import React from '../../vendor/react';
import type { ButtonHTMLAttributes, ReactNode } from '../../vendor/react';
import { cn } from '../../lib/cn';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  icon?: ReactNode;
};

export function Button({
  className,
  variant = 'primary',
  size = 'md',
  icon,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button className={cn('button', `button--${variant}`, `button--${size}`, className)} type={type} {...props}>
      {icon}
      {children}
    </button>
  );
}
